import { IMenuGroup } from '@/api/restaurants/types/restaurant-types'
import { RestaurantDetailMenuItem } from '@/features/restaurants/restaurant-detail/restaurant-detail-menu/restaurant-detail-menu-item'

interface IRestaurantDetailMenuGroupProps {
    menuGroup: IMenuGroup
    currencySymbol: string
    highlightQuery?: string
}

export const RestaurantDetailMenuGroup = ({
    menuGroup,
    currencySymbol,
    highlightQuery,
}: IRestaurantDetailMenuGroupProps) => {
    if (!menuGroup.menuItems?.length) return null

    return (
        <div className="flex flex-col">
            <h3 className="text-h4 mb-4">{menuGroup.name}</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-4 md:gap-y-5">
                {menuGroup.menuItems.map((menuItem) => (
                    <RestaurantDetailMenuItem
                        currencySymbol={currencySymbol}
                        highlightQuery={highlightQuery}
                        key={'restaurant-detail-menu-group' + menuGroup.uuid + menuItem.uuid}
                        menuItem={menuItem}
                    />
                ))}
            </div>
        </div>
    )
}
